import React from 'react';
import { ProjectArchetype } from '@dreamai/types';
import { ReactComponent as LuggageIcon } from '../../icons/luggage-03.svg';
import { ReactComponent as TargetIcon } from '../../icons/target-04.svg';
import { ReactComponent as AnnouncementIcon } from '../../icons/announcement-02.svg';
import { ReactComponent as TelescopeIcon } from '../../icons/telescope.svg';
import { ReactComponent as GraduationHatIcon } from '../../icons/graduation-hat-01.svg';

/**
 * Maps a project archetype to its Untitled UI line icon (matching the Figma
 * archetype icon set). Falls back to the ops-runner target icon when the
 * archetype is unknown or the project has no charter yet.
 */
const ARCHETYPE_ICONS: Record<
  ProjectArchetype,
  React.FunctionComponent<React.SVGProps<SVGSVGElement>>
> = {
  travel_planner: LuggageIcon,
  ops_runner: TargetIcon,
  coach: AnnouncementIcon,
  researcher: TelescopeIcon,
  tutor: GraduationHatIcon,
};

interface ArchetypeIconProps {
  archetype: ProjectArchetype | null;
}

const ArchetypeIcon: React.FC<ArchetypeIconProps> = ({ archetype }) => {
  const Icon = (archetype && ARCHETYPE_ICONS[archetype]) || TargetIcon;
  return (
    <span className='archetype-icon'>
      <Icon />
    </span>
  );
};

export default ArchetypeIcon;
